(() => {
  const ROOT_SELECTOR = '[data-gameday-social-share]';

  const root = document.querySelector(ROOT_SELECTOR);
  if (!root || root.dataset.socialReady === 'true') return;
  root.dataset.socialReady = 'true';

  const dialog = root.querySelector('[data-share-dialog]');
  const titleNode = root.querySelector('[data-share-dialog-title]');
  const messageNode = root.querySelector('[data-share-message]');
  const previewImageWrap = root.querySelector('[data-share-preview-image-wrap]');
  const previewImage = root.querySelector('[data-share-preview-image]');
  const previewTitle = root.querySelector('[data-share-preview-title]');
  const previewDescription = root.querySelector('[data-share-preview-description]');
  const previewDomain = root.querySelector('[data-share-preview-domain]');
  const previewDestination = root.querySelector('[data-share-preview-destination]');
  const statusNode = root.querySelector('[data-share-status]');
  const nativeButtons = root.querySelectorAll('[data-share-native]');
  const copyButtons = root.querySelectorAll('[data-share-copy]');
  const platformLinks = root.querySelectorAll('[data-share-platform]');
  const closeButtons = root.querySelectorAll('[data-share-close]');

  const base = {
    productTitle: root.dataset.productTitle || document.title,
    productHandle: root.dataset.productHandle || '',
    productUrl: root.dataset.productUrl || window.location.href,
    imageUrl: root.dataset.productImage || '',
    productDescription: root.dataset.productDescription || '',
    designId: '',
    designTitle: '',
    campaign: root.dataset.shareCampaign || 'gameday_product_share',
  };

  let active = { ...base };

  const cleanUrl = (value) => {
    const url = new URL(value, window.location.origin);
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach((key) => url.searchParams.delete(key));
    return url;
  };

  const slug = (value) => String(value || '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '') || 'product';

  const trackedUrl = (platform) => {
    const url = cleanUrl(active.productUrl);
    if (active.designId) url.searchParams.set('design', active.designId);
    url.searchParams.set('utm_source', platform);
    url.searchParams.set('utm_medium', 'social');
    url.searchParams.set('utm_campaign', active.campaign);
    url.searchParams.set('utm_content', active.designId || slug(active.productHandle || active.productTitle));
    if (active.designId) url.hash = `gameday-design-${active.designId}`;
    else url.hash = 'gameday-social-share';
    return url.toString();
  };

  const shareTitle = () => active.designTitle
    ? `${active.designTitle} Authentic Gameday Flag`
    : active.productTitle;

  const shareText = () => active.designTitle
    ? `See the ${active.designTitle} Authentic Gameday Flag and follow its release.`
    : active.productDescription || `See ${active.productTitle} and follow its release.`;

  const previewUrl = () => {
    const url = cleanUrl(active.productUrl);
    if (active.designId) url.searchParams.set('design', active.designId);
    return url;
  };

  const publish = (name, platform, outcome = 'intent') => {
    const payload = {
      platform,
      outcome,
      product_handle: active.productHandle,
      design_id: active.designId,
      design_title: active.designTitle,
      share_url: trackedUrl(platform),
    };
    try {
      if (window.Shopify?.analytics?.publish) {
        window.Shopify.analytics.publish(`exo:${name}`, payload).catch(() => {});
      }
    } catch (_) {}
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: `exo_${name.replace(':', '_')}`, ...payload });
  };

  const setStatus = (message) => {
    if (!statusNode) return;
    statusNode.textContent = message;
    window.clearTimeout(setStatus.timer);
    setStatus.timer = window.setTimeout(() => { statusNode.textContent = ''; }, 5200);
  };

  const copyText = async (value) => {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(value);
      return;
    }
    const input = document.createElement('textarea');
    input.value = value;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    input.remove();
  };

  const platformHref = (platform) => {
    const url = trackedUrl(platform);
    const text = shareText();
    if (platform === 'facebook') return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
    if (platform === 'pinterest') {
      const media = active.imageUrl ? `&media=${encodeURIComponent(active.imageUrl)}` : '';
      return `https://www.pinterest.com/pin/create/button/?url=${encodeURIComponent(url)}${media}&description=${encodeURIComponent(text)}`;
    }
    if (platform === 'x') return `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`;
    return url;
  };

  const refresh = () => {
    if (titleNode) titleNode.textContent = shareTitle();
    if (messageNode) messageNode.textContent = shareText();
    if (previewTitle) previewTitle.textContent = shareTitle();
    if (previewDescription) previewDescription.textContent = shareText();
    const destination = previewUrl();
    if (previewDomain) previewDomain.textContent = destination.hostname.replace(/^www\./, '');
    if (previewDestination) {
      previewDestination.textContent = `${destination.hostname.replace(/^www\./, '')}${destination.pathname}${destination.search}`;
      previewDestination.href = destination.toString();
    }
    if (previewImage && previewImageWrap) {
      previewImage.src = active.imageUrl || '';
      previewImage.alt = active.designTitle
        ? `${active.designTitle} share preview`
        : `${active.productTitle} share preview`;
      previewImageWrap.hidden = !active.imageUrl;
    }
    platformLinks.forEach((link) => {
      const platform = link.dataset.sharePlatform;
      link.href = platformHref(platform);
    });
  };

  const open = (context = {}) => {
    active = { ...base, ...context };
    refresh();
    if (dialog?.showModal) dialog.showModal();
    else root.classList.add('is-share-open');
  };

  const close = () => {
    if (dialog?.open) dialog.close();
    root.classList.remove('is-share-open');
  };

  const cardContext = (button) => {
    const article = button.closest('article');
    const designImage = article?.querySelector('img');
    const designId = button.dataset.designId || article?.querySelector('[data-design-id]')?.dataset.designId || '';
    const designTitle = article?.querySelector('.catalog-design-card__identity strong')?.textContent?.trim()
      || article?.querySelector('strong')?.textContent?.trim()
      || designId.replace(/-/g, ' ');
    const imageUrl = designImage?.currentSrc || designImage?.src || base.imageUrl;
    return { designId, designTitle, imageUrl };
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('button[data-design-id]');
    if (!button) return;
    const label = `${button.getAttribute('aria-label') || ''} ${button.textContent || ''}`.toLowerCase();
    if (!label.includes('share')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    open(cardContext(button));
    publish('gameday_share_panel_opened', 'catalog');
  }, true);

  root.querySelectorAll('[data-share-open]').forEach((button) => {
    button.addEventListener('click', () => {
      open();
      publish('gameday_share_panel_opened', 'product');
    });
  });

  nativeButtons.forEach((button) => {
    button.hidden = typeof navigator.share !== 'function';
    button.addEventListener('click', async () => {
      const platform = button.dataset.shareNative || 'native';
      publish('gameday_share_intent', platform);
      try {
        await navigator.share({ title: shareTitle(), text: shareText(), url: trackedUrl(platform) });
        publish('gameday_share_completed', platform, 'shared');
        setStatus('Shared. Thank you for helping bring this flag to gameday.');
      } catch (error) {
        if (error?.name !== 'AbortError') setStatus('Sharing was unavailable. Use Copy link instead.');
      }
    });
  });

  copyButtons.forEach((button) => {
    button.addEventListener('click', async () => {
      const platform = button.dataset.shareCopy || 'copy';
      publish('gameday_share_intent', platform);
      if (platform === 'instagram') window.open('https://www.instagram.com/', '_blank', 'noopener,noreferrer');
      if (platform === 'tiktok') window.open('https://www.tiktok.com/', '_blank', 'noopener,noreferrer');
      try {
        await copyText(trackedUrl(platform));
        publish('gameday_share_completed', platform, 'copied');
        setStatus(platform === 'copy'
          ? 'Campaign link copied.'
          : `Campaign link copied. Paste it into ${platform === 'instagram' ? 'Instagram' : 'TikTok'}.`);
      } catch (_) {
        setStatus('Copy failed. Select and copy the page address from your browser.');
      }
    });
  });

  platformLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      const platform = link.dataset.sharePlatform;
      publish('gameday_share_intent', platform);
      event.preventDefault();
      const popup = window.open(
        '',
        `gameday-share-${platform}`,
        'popup=yes,width=760,height=760,menubar=no,toolbar=no,location=yes,resizable=yes,scrollbars=yes',
      );
      if (popup) {
        try { popup.opener = null; } catch (_) {}
        popup.location.replace(link.href);
      } else {
        window.open(link.href, '_blank', 'noopener,noreferrer');
      }
    });
  });

  closeButtons.forEach((button) => button.addEventListener('click', close));
  dialog?.addEventListener('click', (event) => { if (event.target === dialog) close(); });

  const requestedDesign = new URL(window.location.href).searchParams.get('design');
  if (requestedDesign) {
    const selector = `[data-design-id="${CSS.escape(requestedDesign)}"]`;
    const designButton = document.querySelector(`article ${selector}`) || document.querySelector(selector);
    if (designButton) {
      window.setTimeout(() => {
        const selectable = designButton.closest('article')?.querySelector('button[data-design-id]') || designButton;
        selectable.click();
        selectable.closest('article')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 350);
    }
  }
})();

